import apiFetch from '../apiFetch'

export default function (token, massiveDownloadId) {
  return apiFetch({ endPoint: `Document/MassiveDownload/${massiveDownloadId}/DownloadFile`, parseBlobAndAssign: true, method: 'GET', body: null, token: token })
}
